import { default as _91_46_46_46slug_930w7MtumJpMMeta } from "/builds/common/airbaltic-com/investors/pages/[...slug].vue?macro=true";
export default [
  {
    name: _91_46_46_46slug_930w7MtumJpMMeta?.name ?? "slug___en",
    path: _91_46_46_46slug_930w7MtumJpMMeta?.path ?? "/en/:slug(.*)*",
    meta: _91_46_46_46slug_930w7MtumJpMMeta || {},
    alias: _91_46_46_46slug_930w7MtumJpMMeta?.alias || [],
    redirect: _91_46_46_46slug_930w7MtumJpMMeta?.redirect || undefined,
    component: () => import("/builds/common/airbaltic-com/investors/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_930w7MtumJpMMeta?.name ?? "slug___lv",
    path: _91_46_46_46slug_930w7MtumJpMMeta?.path ?? "/lv/:slug(.*)*",
    meta: _91_46_46_46slug_930w7MtumJpMMeta || {},
    alias: _91_46_46_46slug_930w7MtumJpMMeta?.alias || [],
    redirect: _91_46_46_46slug_930w7MtumJpMMeta?.redirect || undefined,
    component: () => import("/builds/common/airbaltic-com/investors/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_930w7MtumJpMMeta?.name ?? "slug___lt",
    path: _91_46_46_46slug_930w7MtumJpMMeta?.path ?? "/lt/:slug(.*)*",
    meta: _91_46_46_46slug_930w7MtumJpMMeta || {},
    alias: _91_46_46_46slug_930w7MtumJpMMeta?.alias || [],
    redirect: _91_46_46_46slug_930w7MtumJpMMeta?.redirect || undefined,
    component: () => import("/builds/common/airbaltic-com/investors/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_930w7MtumJpMMeta?.name ?? "slug___et",
    path: _91_46_46_46slug_930w7MtumJpMMeta?.path ?? "/et/:slug(.*)*",
    meta: _91_46_46_46slug_930w7MtumJpMMeta || {},
    alias: _91_46_46_46slug_930w7MtumJpMMeta?.alias || [],
    redirect: _91_46_46_46slug_930w7MtumJpMMeta?.redirect || undefined,
    component: () => import("/builds/common/airbaltic-com/investors/pages/[...slug].vue").then(m => m.default || m)
  }
]